/**
 * Validates obj is an instance of IErrorObject
 * @param obj
 */
function isErrorObject(obj) {
  var errorObj = obj;
  return 'error' in errorObj && !!errorObj.error;
}

export { isErrorObject };